import _ from 'underscore';

const globalLegacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/campaign-creation-advanced');

export const getDateSettingDetails = (i18n, startDate, endDate, isUseCampaignLevelDates = false, isDateLevelDisplayed = false) => {
  const start = startDate ? i18n.getString(_TL_('Starting from {{startDate}}'), { startDate: i18n.dateFormatter({ skeleton: 'yMd' })(startDate) }) : '';

  const end = endDate ? i18n.getString(_TL_('to {{endDate}}'), { endDate: i18n.dateFormatter({ skeleton: 'yMd' })(endDate) }) : '';

  if (isDateLevelDisplayed) {
    const managementLevel = isUseCampaignLevelDates ? _TL_('managed at the campaign level') : _TL_('managed at the ad group level');
    const dateRange = endDate
      ? i18n.getString(_TL_('{{startFromDate}} {{endToDate}}'), { startFromDate: start, endToDate: end })
      : i18n.getString(_TL_('{{startFromDate}}'), { startFromDate: start });

    return i18n.getString(_TL_('{{dateRange}}, {{managementLevel}}'), { dateRange, managementLevel });
  }

  return i18n.getString(_TL_('{{startFromDate}} {{endToDate}}'), { startFromDate: start, endToDate: end });
};

export const convertDateBetweenTimeZones = (date, {
  from,
  to,
} = {}) => {
  const dateString = globalLegacyI18n.formatDate(date, {
    timeZone: from,
    raw: 'yyyy-MM-dd',
  });

  return globalLegacyI18n.parseDate(dateString, {
    timeZone: to,
    raw: 'yyyy-MM-dd',
  });
};

export const getCurrentDate = () => convertDateBetweenTimeZones(new Date());

export const validateDate = ({
  StartDate,
  EndDate,
  hasFixedStartDate = false,
}, i18n) => {
  const validationErrors = [];

  const currentDate = getCurrentDate();

  // check wether date is valid
  if (_.isNull(StartDate) && !hasFixedStartDate) {
    validationErrors.push(i18n.getString(_TL_('Invalid start date')));
  } else if (StartDate < currentDate && !hasFixedStartDate) {
    validationErrors.push(i18n.getString(_TL_("Your start date must be after today. Today's date is calculated using your campaign time zone setting, not your actual local time.")));
  } else if (!_.isNull(EndDate) && StartDate > EndDate) {
    validationErrors.push(StartDate > EndDate ? i18n.getString(_TL_('End date must be later than start date')) : '');
  }
  return validationErrors;
};

export const numberOfDaysBetweenDates = (startDate, endDate) => {
  const ONE_DAY = 24 * 60 * 60 * 1000;

  const startDateUTC = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endDateUTC = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  return Math.floor(Math.abs((endDateUTC - startDateUTC) / ONE_DAY));
};

export const getLaterDate = (startDate, numberOfDaysLater) =>
  convertDateBetweenTimeZones(new Date(new Date().setDate(startDate.getDate() + numberOfDaysLater)));
